import * as React from "react";
import type { SVGProps } from "react";
const SvgReceipt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18.24 3H5.76c-.862 0-1.56.806-1.56 1.8V21l2.6-1.8L9.4 21l2.6-1.8 2.6 1.8 2.6-1.8 2.6 1.8V4.8c0-.994-.698-1.8-1.56-1.8Z"
    />
  </svg>
);
export default SvgReceipt;
